import {Icon} from '../../../app/components/Icon';
import {BiotwinScore} from '../types';
import {ConditionTypeTag} from './ConditionTypeTag';
export interface ScoreInfoProps {
  biotwinScore: BiotwinScore;
  className?: string;
}
export const ScoreInfo = ({biotwinScore, className}: ScoreInfoProps) => {
  return (
    <div className={className}>
      <div className="flex gap-6 items-center">
        <div className="w-[6rem] h-[6rem] rounded-full bg-brand text-white flex flex-col items-center justify-center gap-1">
          <span className="text-3xl">{biotwinScore.scoreValue}</span>
          <span className="text-base">{biotwinScore.scoreValueUnit}</span>
        </div>
        <p className="flex-1 m-0">{biotwinScore.scoreLongDescription ?? biotwinScore.scoreShortDescription}</p>
      </div>
      {biotwinScore.hasMissingInformation && (
        <div className="mt-6">
          <div className="text-yellow-400 mb-4">
            <Icon icon="exclamation-triangle" /> Missing Information
          </div>
          <div className="flex items-center gap-4">
            {biotwinScore.missingConditions.map((condition) => (
              <div className="flex items-center gap-2" key={condition.id}>
                <ConditionTypeTag conditionTypeName={condition.conditionTypeName} /> {condition.conditionName}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
